// Fragmento ESPAÑOL del lote « règles » : Reglas del juego (/regles-de-jeu, destino
// del código QR de la caja), Pedido realizado (/success) y página 404.
// COHERENCIA : las preguntas 5, 7 y 11 se repiten idénticas en
// es/experience.js (demo.question.*) — cualquier retoque aquí debe
// repercutirse allí. La pregunta de desempate de la demo
// (demo.subsidiaire.question) es DELIBERADAMENTE otra: la portada nunca
// desvela la de verdad.
// A VERIFICAR con la imprenta : si la caja incluye una guía en español, estas
// 11 preguntas deben reproducir su redacción exacta.
// NB : la respuesta a la pregunta de desempate NO tiene clave a propósito :
// solo debe existir en GameRules.jsx, detrás del clic « solo para los padres ».
export default {
  // --- Reglas del juego : SEO ---
  'regles.seo.titre': 'Reglas del juego Joyful Reveal',
  'regles.seo.description':
    'Las reglas completas del juego de gender reveal Joyful Reveal: forme dos equipos, responda a las 11 preguntas, monte el puzle y rasque la pieza final que revela el sexo del bebé.',

  // --- Reglas del juego : encabezado ---
  'regles.entete.titre': 'Las reglas del juego',
  'regles.entete.introAvant':
    'Dos equipos, 11 preguntas, un puzle que montar y una pieza final que rascar. Calcule unos',
  'regles.entete.introDuree': '20 minutos',
  'regles.entete.introEntre': ', de',
  'regles.entete.introJoueurs': '2 a 10 jugadores',

  // --- Reglas del juego : aviso a los invitados ---
  'regles.invite.titre': '🤫 ¿Le han invitado a una fiesta?',
  'regles.invite.destinee': 'Esta página está pensada para los',
  'regles.invite.parents': 'futuros padres',
  'regles.invite.suite':
    'que preparan el juego. Si usted es uno de los jugadores, ciérrela: ¡se estropearía su propia sorpresa!',

  // --- Reglas del juego : contenido del kit ---
  'regles.kit.titre': '🎁 Lo que contiene su kit',
  'regles.kit.sachetAvant': 'Una bolsa principal que contiene',
  'regles.kit.sachetPieces': '11 piezas de puzle',
  'regles.kit.grattoirAvant': 'y',
  'regles.kit.grattoirPiece': 'una pieza única rascable',
  'regles.kit.grattoirFin': '— la que lo revela todo.',
  'regles.kit.premium':
    'El Pack Premium añade las dos bolsitas de equipo, el cuestionario impreso en cartón de 400 g y el sobre de recuerdo que se pega al dorso de un marco después de la fiesta.',

  // --- Reglas del juego : las 4 etapas ---
  'regles.etape1.titre': 'Antes de que lleguen los invitados',
  'regles.etape1.alt':
    'El contenido del juego Joyful Reveal extendido: la caja, la ficha del concurso y las dos bolsitas',
  'regles.etape1.p1':
    'Los futuros padres eligen las 11 preguntas que tendrán que responder los jugadores. Cada respuesta acertada gana una pieza del puzle.',
  'regles.etape1.p2':
    'Las respuestas son siempre «mamá» o «papá» — ¡y hay que tomárselas con humor, por supuesto!',
  'regles.etape1.p3':
    'Puede usar nuestra lista ya preparada (más abajo) o inventar las suyas con la plantilla en blanco.',

  'regles.etape2.titre': 'Forme los dos equipos',
  'regles.etape2.alt': 'Las dos bolsitas de tela del juego, etiquetadas Equipo 1 y Equipo 2',
  'regles.etape2.p1': 'Reparta a sus invitados en dos equipos — por ejemplo:',
  'regles.etape2.equipe1Label': 'Equipo 1',
  'regles.etape2.equipe1Texte': 'los que creen que el bebé será una niña 💗',
  'regles.etape2.equipe2Label': 'Equipo 2',
  'regles.etape2.equipe2Texte': 'los que creen que el bebé será un niño 💙',

  'regles.etape3.titre': 'El juego: ganar las 11 piezas',
  'regles.etape3.alt': 'Parte trasera de la caja Joyful Reveal con las 4 etapas del juego',
  'regles.etape3.p1':
    'Los futuros padres van planteando las preguntas una a una. El primer equipo que da la respuesta correcta gana una pieza del puzle.',
  'regles.etape3.p2': 'Así se continúa hasta las 11 piezas clásicas.',
  'regles.etape3.p3':
    'Una vez ganadas las 11 piezas, los dos equipos cooperan para montar el puzle… ¡y solo falta una pieza!',

  'regles.etape4.titre': 'La última pieza: la gran revelación',
  'regles.etape4.alt': 'La caja del juego Joyful Reveal con la pieza de puzle rascable',
  'regles.etape4.p1':
    'Solo el equipo que haya conseguido más piezas tiene derecho a jugar esta última ronda — y esta vez cada jugador juega de forma individual.',
  'regles.etape4.p2':
    'Los futuros padres plantean entonces la pregunta de desempate. El jugador cuya estimación se acerque más gana la última pieza… ¡y el privilegio de rascarla!',

  // --- Reglas del juego : pregunta de desempate (la respuesta se queda en el JSX) ---
  'regles.subsidiaire.surtitre': 'La pregunta de desempate',
  'regles.subsidiaire.question':
    '«De media, ¿cuántos pañales desechables usan los padres primerizos durante el primer año del bebé?»',
  'regles.subsidiaire.reponseLabel': 'Respuesta:',
  'regles.subsidiaire.bouton': '👀 Mostrar la respuesta (solo para los padres)',
  'regles.subsidiaire.libre':
    'Es nuestra pregunta favorita — pero elija la suya si lo prefiere: basta con que la respuesta sea un número que estimar.',

  // --- Reglas del juego : el consejo ---
  'regles.conseil.surtitre': '💡 Un pequeño consejo',
  'regles.conseil.titre': '¡Resista la tentación de avisar a sus invitados!',
  'regles.conseil.texte':
    'Imagine su reacción cuando descubran el juego y se den cuenta de que están a punto de vivir un momento único, lleno de suspense. Merece muchísimo la pena ver cómo se les iluminan las caras. Así que aguante: ¡no desvele su secreto!',

  // --- Reglas del juego : las 11 preguntas ---
  'regles.questions.titre': '📝 Las 11 preguntas listas para jugar',
  'regles.questions.imprimer': '🖨️ Imprimir',
  'regles.questions.q1': '¿Quién cocina mejor los purés del bebé?',
  'regles.questions.q2': '¿Quién tiene más papeletas para entrar en pánico durante el parto?',
  'regles.questions.q3':
    '¿Quién se acordará más fácilmente de la talla y el peso del bebé al nacer?',
  'regles.questions.q4': '¿A quién le costará más cambiar los pañales del bebé?',
  'regles.questions.q5': '¿Quién cantará las nanas de forma desastrosa?',
  'regles.questions.q6': '¿Quién no se resistirá a comprar ropita mona pero inútil para el bebé?',
  'regles.questions.q7': '¿Quién llorará con las películas infantiles?',
  'regles.questions.q8': '¿Quién pondrá las mejores muecas para hacer reír al bebé?',
  'regles.questions.q9':
    '¿Quién es más propenso a no entender cómo se le pone la ropa al bebé?',
  'regles.questions.q10': '¿Quién cuenta mejor los cuentos para dormir al bebé?',
  'regles.questions.q11':
    '¿Quién podría despertar al bebé sin querer al pisar un juguete ruidoso?',
  'regles.questions.persoAvant':
    '¿Quiere personalizarlas? Sustituya libremente estas preguntas por las suyas — lo importante es que la respuesta sea siempre',
  'regles.questions.persoMaman': '«mamá»',
  'regles.questions.persoOu': 'o',
  'regles.questions.persoPapa': '«papá»',
  'regles.questions.persoFin':
    '. El Pack Premium incluye una plantilla en blanco pensada para eso.',

  // --- Reglas del juego : CTA final ---
  'regles.cta.titre': '¿Todavía no tiene su juego?',
  'regles.cta.texte': 'Que se diviertan mucho — ¡y enhorabuena otra vez, futuros padres! 🎉',
  'regles.cta.bouton': '🛒 Descubrir el juego',

  // --- Página 404 (NotFound.jsx), colocada bajo « regles » a falta de espacio propio ---
  'regles.introuvable.seoTitre': '404 - Página no encontrada',
  'regles.introuvable.seoDescription':
    'La página que busca no existe. Vuelva al inicio o explore nuestra tienda.',
  'regles.introuvable.titre': '404 - ¡Vaya!',
  'regles.introuvable.sousTitre': 'No hemos podido encontrar la página que busca.',
  'regles.introuvable.texte':
    'Puede que la página se haya eliminado o movido, o que la URL sea incorrecta.',
  'regles.introuvable.boutonAccueil': '🏠 Volver al inicio',
  'regles.introuvable.boutonBoutique': '🛍️ Ver la tienda',
  'regles.introuvable.aide': '¿Necesita ayuda?',
  'regles.introuvable.aideLien': 'Contacte con nosotros',

  // --- Pedido realizado (Success.jsx) ---
  'succes.chargement.titre': 'Finalizando su pedido...',
  'succes.chargement.texte':
    'Estamos recuperando su número de seguimiento, no tardará mucho.',
  'succes.entete.titre': '¡Pedido realizado!',
  'succes.entete.numeroLabel': 'Número de pedido:',
  'succes.entete.merci':
    '¡Gracias por su compra! Va a recibir un correo de confirmación con los detalles de su pedido y su factura.',
  'succes.suivi.titre': 'Seguimiento de su paquete',
  'succes.suivi.etiquette': '¡Su etiqueta de envío ya está creada!',
  'succes.suivi.numeroLabel': 'N.º de seguimiento:',
  'succes.suivi.bouton': '🚚 Seguir mi paquete',
  'succes.suivi.astuce':
    '💡 También puede encontrar este enlace en su perfil → Mis pedidos',
  'succes.attente.texte':
    'Su pedido se está preparando. El número de seguimiento estará disponible en breve en su área de cliente.',
  // Guía de reglas descargable. Contiene la respuesta de la pregunta de
  // desempate : el aviso no es decorativo.
  // Affiché quand la session de paiement n'est plus lisible (lien rouvert
  // des semaines plus tard) : la page restait alors amputée EN SILENCE —
  // ni numéro de commande, ni guide, ni facture, et aucune explication.
  'succes.introuvable.texte':
    "Tu pago se ha realizado correctamente. Solo que no podemos mostrar aquí los detalles de este pedido: ocurre cuando se vuelve a abrir este enlace más tarde. Tu correo de confirmación incluye el número de pedido y la factura; escríbenos si no lo encuentras.",
  'succes.guide.titre': 'Su guía del juego',
  'succes.guide.texte':
    'El librito completo, con las 11 preguntas listas para jugar y la plantilla en blanco para escribir las suyas. Téngalo a mano el gran día.',
  'succes.guide.bouton': '📥 Descargar la guía (PDF)',
  'succes.guide.avertissement':
    '⚠️ Solo para los futuros padres: revela la respuesta de la pregunta de desempate.',

  'succes.questionnaire.titre': 'Su cuestionario recuerdo',
  'succes.questionnaire.texte':
    'La hoja del quiz lista para imprimir, con el mismo formato que la tarjeta del juego: las 11 preguntas y las columnas de los equipos. Marque la casilla para una versión en blanco, para rellenar con sus propias preguntas.',
  'succes.questionnaire.vierge': 'Versión en blanco (para escribir sus propias preguntas)',
  'succes.questionnaire.bouton': '📥 Descargar el cuestionario (PDF)',
  'succes.questionnaire.avertissement':
    '⚠️ Solo para los futuros padres: el reverso revela la respuesta de la pregunta de desempate.',

  "succes.facture.titre": "Su factura",
  "succes.facture.texte":
    "La factura de su pedido (en francés) está lista. Stripe le envía además un recibo de pago por correo electrónico.",
  "succes.facture.bouton": "🧾 Ver e imprimir la factura",
  'succes.avis.titre': '¡Su valoración cuenta!',
  'succes.avis.texte':
    'Comparta su experiencia y ayude a otros clientes a descubrir nuestros productos.',
  'succes.avis.bouton': '✍️ Dejar una valoración',
  'succes.actions.commandes': '📋 Ver mis pedidos',
  'succes.actions.boutique': '🎮 Seguir comprando',
};
